import { FARMING, PATHOLOGY, PHARMACY, REPORT, VACCIANTION } from '@/constants/routes';
import { OrganizationLevelType } from '@/shared/organizations/enums';
import { administration } from '@/shared/security/permissions/administration';
import { farm } from '@/shared/security/permissions/farm';
import { pathology } from '@/shared/security/permissions/pathology';
import { pharmacy } from '@/shared/security/permissions/pharmacy';
import { report } from '@/shared/security/permissions/report';
import { vaccination } from '@/shared/security/permissions/vaccination';

export const menuItems = [
  {
    label: 'Вакцинация',
    key: VACCIANTION,
    security: {
      permissions: [
        vaccination.individual.viewList,
        vaccination.eventProtocol.view,
        vaccination.control.viewMonitoring,
        vaccination.task.view,
      ],
    },
  },
  {
    label: 'Аптека',
    key: PHARMACY,
    security: {
      permissions: [pharmacy.dictionary.viewDrugs, pharmacy.monitoring.viewDrugs],
    },
  },
  {
    label: 'Отчетность',
    key: REPORT,
    security: [
      { permissions: report.taskReport.view },
      { permissions: report.summaryReport.view, level: OrganizationLevelType.DISTRICT },
      { permissions: report.mortalityReport.view },
    ],
  },
  {
    label: 'Патологоанатомия',
    key: PATHOLOGY,
    security: { permissions: pathology.act.viewList },
  },
  {
    label: 'Администрирование',
    key: '/administration',
    security: {
      permissions: [
        administration.users.viewList,
        administration.roles.viewList,
        administration.orgs.viewList,
        administration.animalGroups.viewList,
      ],
    },
  },
  {
    label: 'Хозяйство',
    key: FARMING,
    security: { permissions: farm.viewScheme },
  },
];
